import React from 'react';
import BentoCard from '../ui/BentoCard';
import MaterialIcon from '../ui/MaterialIcon';
import { useLoyalty } from '../../contexts/LoyaltyContext';
import { LOYALTY_PROGRAMS_BY_ID } from '../../data/loyaltyPrograms';

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function RecentActivityList({ onLogActivity }) {
  const { activity } = useLoyalty();

  if (activity.length === 0) {
    return (
      <div>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-semibold text-on-surface">Recent Activity</h2>
          <button
            onClick={onLogActivity}
            className="text-sm font-medium text-primary hover:text-primary-dark transition-colors"
          >
            + Log
          </button>
        </div>
        <BentoCard className="flex flex-col items-center py-8 gap-2">
          <MaterialIcon name="receipt_long" size={36} className="text-on-surface-variant/30" />
          <p className="text-sm text-on-surface-variant">No activity logged yet</p>
          <button
            onClick={onLogActivity}
            className="mt-1 text-sm font-medium text-primary"
          >
            Log your first transaction →
          </button>
        </BentoCard>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-on-surface">Recent Activity</h2>
        <button
          onClick={onLogActivity}
          className="text-sm font-medium text-primary hover:text-primary-dark transition-colors"
        >
          + Log
        </button>
      </div>

      <BentoCard className="!p-0 overflow-hidden divide-y divide-outline-variant/10">
        {activity.slice(0, 8).map((item) => {
          const program = LOYALTY_PROGRAMS_BY_ID.get(item.programId);
          const icon = program?.icon || 'loyalty';
          const isEarned = item.type === 'earned';

          return (
            <div key={item.id} className="flex items-center gap-3 px-5 py-3.5">
              <div className="w-9 h-9 rounded-xl bg-surface-container-low flex items-center justify-center shrink-0">
                <MaterialIcon name={icon} size={20} className="text-on-surface-variant" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-on-surface truncate">{item.description}</p>
                <p className="text-xs text-on-surface-variant mt-0.5">
                  {item.programName} · {formatDate(item.date)}
                </p>
              </div>
              <div className="text-right shrink-0">
                <p className={`text-sm font-semibold ${isEarned ? 'text-success' : 'text-error'}`}>
                  {isEarned ? '+' : '−'}{item.points.toLocaleString()}
                </p>
                <p className="text-xs text-on-surface-variant">{item.unit}</p>
              </div>
            </div>
          );
        })}
      </BentoCard>
    </div>
  );
}

export default RecentActivityList;
